const KEY = "@implements";

export function instanceOfInterface<T>(obj: any, interfaceName: string): obj is T {
    if (obj === undefined || obj === null) {
      return false;
    }

    const set = obj.__proto__ && obj.__proto__[KEY];
    return Boolean(set && set.has(interfaceName));
}

export function classImplementsInterfaces(klass: any, ...interfaces: string[]) {
    klass.prototype[KEY] = new Set(interfaces);
}
